/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {LitElement, html, property, CSSResultArray, TemplateResult} from 'lit-element';
import { customElement } from 'lit/decorators.js';
import {styles} from './nile-toolbar.css';

/**
 * Nile icon component.
 *
 * @tag nile-toolbar
 *
 */
@customElement('nile-toolbar')
export class NileToolbar extends LitElement {

	/**
	 * The styles for Toolbar
	 * @remarks If you are extending this class you can extend the base styles with super. Eg `return [super(), myCustomStyles]`
	 */
	public static get styles(): CSSResultArray {
		return [styles];
	}

	/* #endregion */

	/* #region Methods */

	/**
	 * Render method
	 * @slot This is a slot test
	 */
	public render(): TemplateResult {
		return html`
			<slot> </slot>
			`;
	}

	/* #endregion */
}

export default NileToolbar;

declare global {
  interface HTMLElementTagNameMap {
    'nile-toolbar': NileToolbar;
  }
}